import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITourService } from "../tourserviceModel";

export const getAllTourServices = createAsyncThunk(
  "TourServices/FindAllTourServices",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/FindAllTourServices`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Food Options:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTourService = createAsyncThunk(
  "TourServices/InsertTourServices",
  async (TourServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/InsertTourServices`,
        TourServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating food option:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTourService = createAsyncThunk(
  "TourServices/UpdateTourServices",
  async (TourServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/UpdateTourServices`,
        TourServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating food option:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTourService = createAsyncThunk(
  "TourServices/DeleteTourServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/DeleteTourServices`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting food option:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTourServiceByID = createAsyncThunk(
  "TourServices/FindByIDTourServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/FindByIDTourServices`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        IsDisplayHome: result.IsDisplayHome,
        Title: result.Title,
        IsActive: result.IsActive ? 1 : 2,
      } as ITourService;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching food option:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTourServices = createAsyncThunk(
  "TourServices/FindAllActiveTourServices",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/TourServices/FindAllActiveTourServices`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Food Options:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveTourService = createAsyncThunk(
  "TourServices/ActiveInActiveTourServices",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/ActiveInActiveTourServices`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive food option:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
